import CustomerLocationHandler from '../modules/CustomerLocationHandler'
import initTabbedCard from '../modules/templates/tabbed-card'

window.$ = window.jQuery = require('jquery');

initTabbedCard()

$('#brand').on('change', function() {
    const brandModels = models.filter(model => model.brand === $(this).val())

    const modelOptions = brandModels.map(({ short_name }) => `
        <option value="${short_name}">${short_name}</option>
    `).join('')

    $('#model').html(`<option value="">Search all models...</options>${modelOptions}`)
})

$('#motabilityForm').on('submit', function(e) {
    e.preventDefault()

    const type = $('#type').val()
    const brand = $('#brand').val()
    const model = $('#model').val()

    window.location = `/${brand}/motability/car-search#sort=price_asc&brand=${brand}&type=${type}&model=${model}&minAdvanceRental=0&maxAdvanceRental=0&trim=&co2=&mpg_combined=&seats=&fuelType=&doors=&bodystyle=&transmission=&engineSize=&finance=undefined`
})

const form = document.querySelector('#findADealerForm')

if (form) {
    let formLocationWord = form.querySelector('input[name="location"]')
    let formLat = form.querySelector('input[name="lat"]')
    let formLng = form.querySelector('input[name="lng"]')

    const locationHandler = new CustomerLocationHandler({
        element: form,
    })

    if (formLat && formLng) {
        locationHandler.onLocationUpdate(function(response) {
            formLat.value = response.lat;
            formLng.value = response.lng;
        });

        // If there's no lat/lng on first load, check if we have one in local storage and use it if so, otherwise blank the location input
        if (formLat.value == '' || formLng.value == '') {
            if (locationHandler.locationKnown()) {
                formLocationWord.value = locationHandler.postcode();
                formLat.value = locationHandler.lat();
                formLng.value = locationHandler.lng();
            } else {
                formLocationWord.value = '';
                formLat.value = '';
                formLng.value = '';
            }
        }
    }

    form.addEventListener('submit', function(e) {
        // If we're still waiting for a response from the geocoder, change the geocoder completed callback to submit form after it completes
        if (locationHandler.waitingForGeocoder == true) {
            form.querySelector('button[type="submit"]').classList.add('input-processing');
            locationHandler.onLocationUpdate(function(response) {
                if (formLat && formLng) {
                    formLat.value = response.lat;
                    formLng.value = response.lng;
                }
                $(form).submit();
            });
            e.preventDefault();
            return false;
        }

        return true;
    })
}